import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router"
import { ConfirmDialog } from "components"
import { teamStatus, message, auth } from "state_management"
import useT from "utils/hooks/useT"

export default function SimulationLogoutConfirm() {

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { t } = useT("messages")
  const { t: tc } = useT("common")
  const showLogoutConfirm = useSelector((state) => state.teamStatus.showLogoutConfirm)

  return (
    showLogoutConfirm && <ConfirmDialog
      onCancel={() => dispatch(teamStatus.showLogoutConfirm(false))}
      onConfirm={() => {
        dispatch(teamStatus.showLogoutConfirm(false))
        dispatch(teamStatus.discardPlanningModeChanges())
          .then(() => {
            dispatch(auth.logout())
            navigate("/login")
          })
          // Overwrite default error message
          // TODO: Find a better way to do this!
          .catch((e) => {
            if (e.name === "IAPinUseError") {
              dispatch(message.warning(t("adhoc.iapRunning")))
            } else {
              dispatch(message.error(t("adhoc.failedDiscardNotLoggedOut")))
            }
          })
      }}
    >
      <h4>{tc("simulationModeLogoutWarning")}</h4>
    </ConfirmDialog>
  )
}
